import { onBeforeUnmount, onMounted, ref } from 'vue';

const CURRENT_VERSION = __APP_VERSION__; // Will be defined by Vite
const CHECK_INTERVAL_MS = 60000; // 1 minute
const VERSION_JSON_URL = '/version.json';

export function useVersionCheck() {
  const newVersionAvailable = ref(false);
  let checkInterval: NodeJS.Timeout | null = null;

  async function checkVersion() {
    try {
      // Add cache-busting query parameter to avoid cached responses
      const response = await fetch(`${VERSION_JSON_URL}?t=${Date.now()}`);
      if (!response.ok) {
        console.warn('Failed to fetch version.json:', response.statusText);
        return;
      }

      const data = await response.json();
      const serverVersion = data.version;

      if (serverVersion && serverVersion !== CURRENT_VERSION) {
        console.log(
          `New version detected: ${serverVersion} (current: ${CURRENT_VERSION})`
        );
        newVersionAvailable.value = true;
        stopChecking(); // Stop polling once we detect a new version
      }
    } catch (error) {
      console.warn('Error checking version:', error);
    }
  }

  function startChecking() {
    // Initial check
    checkVersion();

    // Set up periodic checking
    checkInterval = setInterval(checkVersion, CHECK_INTERVAL_MS);
  }

  function stopChecking() {
    if (checkInterval) {
      clearInterval(checkInterval);
      checkInterval = null;
    }
  }

  onMounted(() => {
    // Only check for version updates in production
    if (process.env.DT_TIER === 'prod') {
      startChecking();
    }
  });

  onBeforeUnmount(() => {
    stopChecking();
  });

  return {
    newVersionAvailable,
  };
}
